import { render, staticRenderFns } from "./dc.vue?vue&type=template&id=1f445b3d&scoped=true&"
import script from "./dc.vue?vue&type=script&lang=js&"
export * from "./dc.vue?vue&type=script&lang=js&"
import style0 from "./dc.vue?vue&type=style&index=0&id=1f445b3d&lang=less&scoped=true&"
import style1 from "./dc.vue?vue&type=style&index=1&id=1f445b3d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f445b3d",
  null
  
)

export default component.exports